import React from 'react';
import NumberFormat from 'react-number-format';

export interface ICurrency {
  className?: string;
  showPrefix?: boolean;
  value: number | null;
  decimalScale?: number;
}

export default class Currency extends React.Component<ICurrency> {
  public static defaultProps: Partial<ICurrency> = {
    className: '',
    showPrefix: true,
    value: null,
    decimalScale: 2,
  };

  public render() {
    return typeof this.props.value === 'number' ? (
      <NumberFormat
        value={this.props.value}
        className={this.props.className}
        decimalScale={this.props.decimalScale}
        displayType={'text'}
        fixedDecimalScale={true}
        prefix={this.props.showPrefix ? '$' : ''}
        thousandSeparator={true}
      />
    ) : null;
  }
}
